import { render } from "./KpsBorderRegimeViolationsView.vue?vue&type=template&id=4d771fa0&scoped=true"
import script from "./KpsBorderRegimeViolationsView.vue?vue&type=script&lang=js"
export * from "./KpsBorderRegimeViolationsView.vue?vue&type=script&lang=js"

import "./KpsBorderRegimeViolationsView.vue?vue&type=style&index=0&id=4d771fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d771fa0"]])

export default __exports__